var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandGunBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Path_11",
    className: "st0",
    d: "M36,12.1V9.4h-0.1V6.9h-0.1V6h-1v0.9c0,0-25.2,0.2-29.6,0c-0.7,0-4.5,0.4-0.7,6.3 c1,1.8,0.8,4.1-0.6,5.6c-2.4,2.9-3.4,8.8-3.7,10.6H0v1.1h10.9v-2c-4.7,0.9,3.3-10.1,2.9-8.3c0.3,0.1,0.5,0.1,0.8,0.1h2.8 c1.8,0,4.1-1.9,4.1-3.6c0-0.7-0.3-1.4-0.7-2h14.1l0.5-1.7h0.6L36,12.1l-0.2,0.1l0-0.1H36z M17.5,18.7h-2.8c-0.2,0-0.4,0-0.6-0.1 c0.2-1,0.3-1.8,0.4-2.5c0.2,0.9,0.8,1.6,1.6,2c0.1,0,0.1,0,0.2,0c0.3,0,0.5-0.2,0.5-0.5c0-0.2-0.1-0.4-0.3-0.5 c-0.9-0.4-1.1-1.8-1.2-2.4H18c1.1,0.3,1.8,1.4,1.5,2.5C19.2,18.1,18.4,18.7,17.5,18.7L17.5,18.7z M32,13H18l2.4-0.8H32V13z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandGunBlu);
export default __webpack_public_path__ + "static/media/hand-gun-blu.9035ceaf.svg";
export { ForwardRef as ReactComponent };